import Vue from 'vue'
import VueRouter from 'vue-router'
import Case from '../views/Case.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Case',
    component: Case
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // window.scrollTo({
  //   top: 0, 
  //   behavior: 'smooth'
  // });
  scrollTo(0,0)
  next()
})


export default router
